/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtPermanentLockPosition = {
  pool: Address;
  position: Address;
  lockLiquidityAmount: bigint;
  totalPermanentLockedLiquidity: bigint;
};

export type EvtPermanentLockPositionArgs = {
  pool: Address;
  position: Address;
  lockLiquidityAmount: number | bigint;
  totalPermanentLockedLiquidity: number | bigint;
};

export function getEvtPermanentLockPositionEncoder(): FixedSizeEncoder<EvtPermanentLockPositionArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["lockLiquidityAmount", getU128Encoder()],
    ["totalPermanentLockedLiquidity", getU128Encoder()],
  ]);
}

export function getEvtPermanentLockPositionDecoder(): FixedSizeDecoder<EvtPermanentLockPosition> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["lockLiquidityAmount", getU128Decoder()],
    ["totalPermanentLockedLiquidity", getU128Decoder()],
  ]);
}

export function getEvtPermanentLockPositionCodec(): FixedSizeCodec<
  EvtPermanentLockPositionArgs,
  EvtPermanentLockPosition
> {
  return combineCodec(
    getEvtPermanentLockPositionEncoder(),
    getEvtPermanentLockPositionDecoder(),
  );
}
